import * as Stomp from 'stompjs';
import axios from "axios";

export default new class {

    initSocketHandler(store) {
        // Configurer axios avec les credentials stockés
        const credentials = sessionStorage.getItem('up_credentials');
        if (credentials) {
            axios.defaults.headers.common['Authorization'] = 'Basic ' + credentials;
        }
        this.connect(store);
    }

    connect(store) {
        // URLs relatives : fonctionne en local (port 8080) comme en prod (port 80/443)
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        let socket = new WebSocket(protocol + '//' + window.location.host + '/ws');
        var ws = Stomp.over(socket);
        ws.debug = null; // Désactiver les logs STOMP en console
        const credentials = sessionStorage.getItem('up_credentials') || '';
        let that = this;
        ws.connect({ 'Authorization': 'Basic ' + credentials }, function (frame) {
            ws.subscribe("/errors", function (message) {
                alert("Error " + message.body);
            });
            ws.subscribe("/topic/teams", function (message) {
                store.commit("setTeams", JSON.parse(message.body));
            });
            ws.subscribe("/topic/stats", function (message) {
                store.commit("setStats", JSON.parse(message.body));
            });
            ws.subscribe("/topic/tournament", function (message) {
                store.commit("setTournament", JSON.parse(message.body));
            });
            ws.subscribe("/topic/matches", function (message) {
                store.commit("setMatches", JSON.parse(message.body));
            });
            ws.subscribe("/topic/tables", function (message) {
                store.commit("setTables", JSON.parse(message.body));
            });
            ws.subscribe("/topic/players", function (message) {
                store.commit("setPlayers", JSON.parse(message.body));
            });
            that.askForData();
            console.log('WebSocket connecté avec succès');
            store.commit("setBackConnected", true);
        }, function (error) {
            console.warn('WebSocket non connecté');
            store.commit("setBackConnected", false);
            setTimeout(() => that.connect(store), 3000);
        });
    }

    askForData() {
        // URL relative : pas de port hardcodé
        axios.get('/dataRequest')
            .then(() => console.log("Données demandées avec succès"))
            .catch(error => console.error("Demande de données en échec : ", error));
    }
}